/* tslint:disable */

/**
 */
export class Error {
    code?: number;
    message?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/error.ts